import React from 'react';
import { Button, Col, Input, ModalV2, Row, Spinner2, Text } from 'components';
import { Avatar } from 'components/Tailwindcss';
import { theme } from 'lib';
import { DetailSection, PlayerSelectItem, SelectionCircle } from '../styles';

const CreatePOTMModal = ({
  visible,
  onClose,
  creatingPOTM,
  handleCreatePOTM,
  potmRewardPoints,
  setPotmRewardPoints,
  selectedPlayerIds,
  teamPlayers,
  loadingTeamPlayers,
  togglePlayerSelection,
  isEditing,
  handleUpdatePOTM
}) => {
  return (
    <ModalV2
      visible={visible}
      closeModal={onClose}
      width="500px"
      header={
        <Col start gap="4px">
          <Text h3 bold>
            {isEditing ? 'Update POTM Poll' : 'Create POTM Poll'}
          </Text>
          <Text c2 col={theme.GREY_60}>
            Select exactly 11 players for the poll
          </Text>
        </Col>
      }
      footer={
        <Row justifyContent="flex-end" gap="12px">
          <Button
            text="Cancel"
            onClick={onClose}
            bg={theme.GREY_20}
            col={theme.GREY_80}
            wid="100px"
          />
          <Button
            text={
              creatingPOTM
                ? isEditing
                  ? 'Updating...'
                  : 'Creating...'
                : isEditing
                  ? 'Update Poll'
                  : 'Create Poll'
            }
            onClick={isEditing ? handleUpdatePOTM : handleCreatePOTM}
            bg={theme.PRIMARY}
            wid="150px"
            disabled={selectedPlayerIds.length !== 11 || creatingPOTM}
          />
        </Row>
      }
    >
      <Col pad="0">
        <DetailSection>
          <Text b2 bold marg="0 0 8px">
            Reward Points
          </Text>
          <Input
            type="number"
            value={potmRewardPoints}
            onChange={(e) => setPotmRewardPoints(parseInt(e.target.value) || 0)}
            placeholder="Points for voting"
          />
        </DetailSection>

        <Row justifyContent="space-between" centerAll marg="0 0 12px">
          <Text b2 bold>
            Players ({selectedPlayerIds.length}/11 selected)
          </Text>
        </Row>

        <Col
          wid="100%"
          ht="400px"
          style={{ overflowY: 'auto' }}
          background="#fff"
          border={`1px solid ${theme.GREY_20}`}
          borderRadius="8px"
        >
          {loadingTeamPlayers ? (
            <Col center pad="40px 0">
              <Spinner2 />
            </Col>
          ) : teamPlayers.length === 0 ? (
            <Col center pad="40px 0">
              <Text b2 col={theme.GREY_60}>
                No players found for this team
              </Text>
            </Col>
          ) : (
            teamPlayers.map((player) => (
              <PlayerSelectItem
                key={player._id}
                selected={selectedPlayerIds.includes(player._id)}
                onClick={() => togglePlayerSelection(player._id)}
              >
                <SelectionCircle selected={selectedPlayerIds.includes(player._id)} />
                <Avatar src={player.photo} size={40}>
                  {player.name?.[0] || player.firstName?.[0]}
                </Avatar>
                <Col gap="2px">
                  <Text b1 bold>
                    {player.name || `${player.firstName} ${player.lastName}`}
                  </Text>
                  {player.number && (
                    <Text c2 col={theme.GREY_60}>
                      #{player.number} • {player.position || 'N/A'}
                    </Text>
                  )}
                </Col>
              </PlayerSelectItem>
            ))
          )}
        </Col>
      </Col>
    </ModalV2>
  );
};

export default CreatePOTMModal;
